import { BaseIp } from "./CommonApi"
 //export const BaseIp = "http://192.168.29.189:8082/"
// export const BaseIp = "http://192.168.29.102:8083/"

export const LoginApi = BaseIp + "system/authentication/login"
export const YearApi = BaseIp + "system/sessionYear/getSessionYearList"

// ====================================MASTERS============================================================
// =======USER MASTER===========================================
export const UserMasterGetAll = BaseIp + "system/authentication/getUserList"
export const UserMasterAdd = BaseIp + "system/authentication/createUser"
export const UserMasterUpdate = BaseIp + "system/authentication/updateUser"
export const UserMasterDelete = BaseIp + "api/User_master/delete"
export const UserMasterBlock = BaseIp + "system/authentication/updateUserStatus"

// =======MINE MASTER===========================================
export const MineMasterFindAll = BaseIp + "master/mineMaster/getMineMasterList"
export const MineMasterAdd = BaseIp + "master/mineMaster/saveMineMaster"
export const MineMasterUpdate = BaseIp + "master/mineMaster/updateMineMaster"
export const MineMasterDelete = BaseIp + "master/mineMaster/deleteMineMaster"
export const MineMasterBlock = BaseIp+"master/mineMaster/blockMineMaster"
export const MineMasterFindAllId = BaseIp + "master/mineMaster/getMineMaster"

// =======PRODUCT MASTER===========================================
export const ProductMasterFindAll = BaseIp + "master/productMaster/getProductMasterList"
export const ProductMasterAdd = BaseIp + "master/productMaster/saveProductMaster"
export const ProductMasterUpdate = BaseIp + "master/productMaster/updateProductMaster"
export const ProductMasterDelete = BaseIp + "master/productMaster/deleteProductMaster"
export const ProductMasterBlock = BaseIp + "master/productMaster/blockProductMaster"
export const ProductMasterFindAllId = BaseIp + "master/productMaster/getProductMaster"

// =======RATE MASTER===========================================
export const RateMasterAdd = BaseIp + "master/rateMaster/saveRateMaster"
export const RateMasterAdUpdate = BaseIp + "master/rateMaster/updateRateMaster"
export const RateMasterAdDelete = BaseIp + "master/rateMaster/deleteRateMaster"
export const RateMasterFindAll = BaseIp + "master/rateMaster/getRateMasterWithProductNameList"
export const RateMasterFindAllId = BaseIp + "master/rateMaster/getRateMaster"

// =======CUSTOMER MASTER===========================================
export const CustomerMasterAdd = BaseIp + "master/customerMaster/saveCustomerMaster"
export const CustomerMasterUpdate = BaseIp + "master/customerMaster/updateCustomerMaster"
export const CustomerMasterDelete = BaseIp + "master/customerMaster/deleteCustomerMaster"
export const CustomerMasterFindAll = BaseIp + "master/customerMaster/getCustomerMasterList"
export const CustomerMasterBlock = BaseIp + "master/customerMaster/blockCustomerMaster"
export const CustomerMasterFindAllById = BaseIp + "master/customerMaster/getCustomerMaster"

// =======BRANCH MASTER===========================================
export const BranchMasterAdd = BaseIp + "master/branchMaster/saveBranchMaster"
export const BranchMasterUpdate = BaseIp + "master/branchMaster/updateBranchMaster"
export const BranchMasterDelete = BaseIp + "master/branchMaster/deleteBranchMaster"
export const BranchMasterFindAll = BaseIp + "master/branchMaster/getBranchMasterList"

// =======EMPLOYEE MASTER===========================================
export const EmployeeMasterAdd = BaseIp + "master/employeeMaster/saveEmployeeMaster"
export const EmployeeMasterUpdate = BaseIp + "master/employeeMaster/updateEmployeeMaster"
export const EmployeeMasterDelete = BaseIp + "master/employeeMaster/deleteEmployeeMaster"
export const EmployeeMasterFindAll = BaseIp + "master/employeeMaster/getEmployeeMasterList"
export const EmployeeMasterFindAllById = BaseIp + "master/employeeMaster/getEmployeeMaster"

// ====================================TRANSACTIONS============================================================

// ====== Employee EXPENSES ENTRY===========================================
export const EmployeeExpensesFindAll = BaseIp + "master/employeePayment/getEmployeePaymentList"
export const EmployeeExpensesAdd = BaseIp + "master/employeePayment/saveEmployeePayment"
export const EmployeeExpensesUpdate = BaseIp + "master/employeePayment/updateEmployeePayment"
export const EmployeeExpensesDelete = BaseIp + "master/employeePayment/deleteEmployeePayment"


// // =======ASSIGN MINE TO USER===========================================
// export const AssignMineToUserAdd = BaseIp + "api/hamali/create"
// export const AssignMineToUserUpdate = BaseIp + "api/hamali/update"
// export const AssignMineToUserDelete = BaseIp + "api/hamali/delete"
// export const AssignMineToUserFindAll = BaseIp + "api/hamali/getAll"

// // =======SALE ENTRY===========================================
// export const SaleEntryAdd = BaseIp + "api/tds/create"
// export const SaleEntryUpdate = BaseIp + "api/tds/update"
// export const SaleEntryDelete = BaseIp + "api/tds/delete"
// export const SaleEntryFindAll = BaseIp + "api/tds/getAll"

// // =======PAYMENT RECEIVE===========================================
// export const PaymentReceiveFindAll = BaseIp + "api/pattidetail/getAll"
// export const PaymentReceiveAdd = BaseIp + "api/pattimain/create"
// export const PaymentReceiveUpdate = BaseIp + "api/pattimain/update"
// export const PaymentReceiveDelete = BaseIp + "api/pattidetail/delete"

// // ======EXPENSES ENTRY===========================================
// export const ExpensesEntryFindAll = BaseIp + "api/pattidetail/getAll"
// export const ExpensesEntryAdd = BaseIp + "api/pattimain/create"
// export const ExpensesEntryUpdate = BaseIp + "api/pattimain/update"
// export const ExpensesEntryDelete = BaseIp + "api/pattidetail/delete"


// ======OPENING BALNACE ENTRY ===========================================
export const OpeningBalanceFindAll = BaseIp +"report/customerBillSummary/getCustomerBillList"
export const OpeningBalanceAdd = BaseIp + "report/customerBillSummary/saveCustomerBill"
export const OpeningBalanceUpdate = BaseIp + "report/customerBillSummary/updateCustomerBill"
export const OpeningBalanceDelete = BaseIp + "report/customerBillSummary/deleteCustomerBill"
export const OpeningBalanceFindAllById = BaseIp + "report/customerBillSummary/getCustomerBill "    
// ====== Year ===========================================
export const getYearList = BaseIp+"system/sessionYear/getSessionYearList"

// =================================================REPORTS===========================================
               
export const ReceiptReport= BaseIp + "report/paymentReceiptSummary/getPaymentReceiptSummaryByDate"            
export const PaymentPendingReport= BaseIp + "report/paymentPendingSummary/getPaymentPendingSummaryList" 
export const DailySaleSummaryReport= BaseIp + "report/dailySaleSummary/generateDailySaleSummary" 
export const ExpenseEntryReport= BaseIp + "report/expencessSummary/getExpencessSummaryList" 
export const EmployeeExpensesReport = BaseIp + "report/employeePaymentSummary/getEmployeePaymentSummaryList"
export const PayExpense = BaseIp + "master/expencessEntry/getBasePay"
export const PayPayment = BaseIp + "master/employeePayment/getBasePay"
export const PayRecieve = BaseIp + "transaction/paymentReceive/getBasePay"

// =================================================Summary===========================================
export const ExpenseEntrySummary= BaseIp + "report/expencessSummary/getExpencessSummary"     
export const PaymentRecieveSummery= BaseIp + "report/paymentReceiptSummary/getPaymentReceiptSummaryList" 
export const PaymentPendingSummary= BaseIp + "report/paymentPendingSummary/getPaymentPendingSummary" 
export const EmployeeExpensesSummary = BaseIp + "report/employeePaymentSummary/getEmployeePaymentSummary"
export const DailySaleSummary= BaseIp + "report/dailySaleSummary/generateDailySaleSummaryList" 
export const AllDailySaleSummary= BaseIp +"report/dailySaleSummary/dailySaleSummary"  

// =================================================DASHBOARD===========================================
export const AdminMineList = BaseIp + "transaction/saleEntryMain/getAdminDashMineList"
export const  AdminTodayMIneExpense = BaseIp + "transaction/saleEntryMain/getAdminDashMineTotal"
export  const AdminYearMineExpense = BaseIp + "transaction/saleEntryMain/getYearlyAllExpenses"
export const  AdminTodayExpense = BaseIp +"master/expencessEntry/getTodayAllExpense"
export const  AdminYearAllExpense = BaseIp +"master/expencessEntry/getYearlyAllExpense"
export const  AdminEmployeeTodayExpense = BaseIp + "master/employeePayment/getTodayAllEmployeeExpense"
export const  AdminYearEmployeeExpense = BaseIp + "master/employeePayment/getYearlyTotalEmployeeExpense"

// ================================================ Change Password ===========================================
export const ChangePasswordAdd = BaseIp + "system/authentication/changePassword"